var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__content"},[_c('ModalContent',{attrs:{"active":_vm.isOpen,"description":_vm.description,"actionLabel":_vm.actionLabel},on:{"action":_vm.closeModal}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }